import React, { useEffect } from 'react';
import styled from 'styled-components';
import FormatSetting from './FormatSetting';
import ReportSettings from './ReportSettings';
import {
  useAiAdminFeature,
  useExternalEmbedFeature,
} from '../../../utils/hooks';
import LlmSettings from './LlmSettings';
import AllowedDomainSettings from './AllowedDomainSettings';
import { useAnalytics } from '../../../utils/analytics/useAnalytics';
import { pageViewed } from '../../../utils/analytics/events/page/events';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

const Settings = () => {
  const aiAdminFeatureEnabled = useAiAdminFeature();
  const externalEmbedFeatureEnabled = useExternalEmbedFeature();
  const { track } = useAnalytics();
  useEffect(() => {
    track(
      pageViewed({
        category: 'settings',
        name: 'settings',
        id: null,
      }),
    );
  }, [track]);

  return (
    <Container>
      <FormatSetting />
      {externalEmbedFeatureEnabled && <AllowedDomainSettings />}
      <ReportSettings />
      {aiAdminFeatureEnabled && <LlmSettings />}
    </Container>
  );
};

export default Settings;
